module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-tabbar mt-bg-lv3 mt-bColor-grey-lv6",
    class: {
      'is-fixed': _vm.fixed
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b7027b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/tabbar/src/tabbar.vue
// module id = 240
// module chunks = 0